<template>
  <!-- <div
    class="h-screen flex w-full bg-primary vx-row no-gutter items-center justify-center"
    id="page-login"
  >-->
  <vx-card>
    <template slot="no-body">
      <img :src="backgroundUrl" class="responsive" @error="replaceImg"/>
      <div class="card-overlay text-white flex flex-col justify-between">
        <div slot="no-body">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2" @click="0">
              <div id="login_data" class="vs-con-loading__container">
                <img
                    alt="login"
                    class="mx-auto"
                    src="../../../assets/images/logo/mapa.png"
                    width="75%"
                />
              </div>
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-primary-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4" style="color: white; font-size: 30px">
                    Login
                  </h4>
                  <p style="color: white; font-size: 16px">
                    Acesse o sistema
                    <b>GSPro </b>
                    <br>
                    <small>frontend build: {{ frontendVersion }}</small><br>
                    <small>backend build: {{ backendVersion }}</small>

                  </p>
                </div>
                <form id="form-login">
                  <h5 style="color: white; font-size: 16px">E-mail</h5>
                  <vs-input
                      v-model="auth.email"
                      autocomplete="off"
                      class="w-full no-icon-border"
                      color="dark"
                      icon="icon icon-mail"
                      icon-pack="feather"
                      name="email"
                      size="large"
                      style="color: black"
                  />
                  <h5 class="mt-5" style="color: white; font-size: 16px">
                    Senha
                  </h5>
                  <vs-input
                      v-model="auth.password"
                      autocomplete="off"
                      class="w-full no-icon-border"
                      color="dark"
                      icon="icon icon-lock"
                      icon-pack="feather"
                      name="password"
                      size="large"
                      style="color: black"
                      type="password"
                  />
                  <div
                      class="flex flex-wrap justify-between my-10"
                      style="font-size: 20px"
                  >
                    <a
                        href="/recuperar-acesso/redefinir"
                        style="color: #c0564b; font-weight: 800"
                    >Esqueci minha senha</a
                    >
                  </div>
                  <vs-button
                      class
                      color="primary"
                      style="color: black; font-weight: 800"
                      @click.prevent="login"
                  >Entrar
                  </vs-button
                  >
                </form>
              </div>
            </div>
          </div>
          <vs-row vs-type="flex">
            <vs-col vs-w="4"></vs-col>
            <vs-col vs-w="4">
              <vs-progress
                  v-if="loading"
                  :height="10"
                  color="primary"
                  indeterminate
              >primary
              </vs-progress
              >
            </vs-col>
            <vs-col vs-w="4"></vs-col>
          </vs-row>
        </div>
      </div>
    </template>
  </vx-card>
  <!-- </div> -->
</template>

<script>
import defBgImage from "../../../assets/images/city/econtrol1280x854.jpg";

export default {
  data() {
    return {
      auth: {},
      error: false,
      ip: "",
      loading: false,
      backgroundUrl: "",
      parametro: {}
    };
  },
  computed: {
    frontendVersion() {
      return process.env.VUE_APP_FRONTEND_VERSION;
    },
    backendVersion() {
      return process.env.VUE_APP_BACKEND_VERSION;
    }
  },
  methods: {
    async login() {
      await this.$vs.loading();
      try {
        const res = await this.$http.post("login", this.auth);
        await this.saveUser(res);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
        ;
      } finally {
        this.$vs.loading.close();
      }
    },
    async getIp() {
      fetch("https://api.ipify.org?format=json")
          .then((x) => x.json())
          .then(({ip}) => {
            this.ip = ip;
          });
    },

    async replaceImg(e) {
      e.target.src = defBgImage;
    },

    async saveUser(res) {
      await window.localStorage.setItem("ip", this.ip);
      await window.localStorage.setItem("token", res.token.token);
      await window.localStorage.setItem("email", res.colaborador.email);
      await window.localStorage.setItem("nome", res.colaborador.nome);
      await window.localStorage.setItem("id", res.colaborador.id);
      await window.localStorage.setItem(
          "imagem_colaborador",
          res.colaborador.foto
      );
      await window.localStorage.setItem(
          "atividades",
          JSON.stringify(res.atividades)
      );
      await this.go();
    },
    async go() {
      window.location.href = await "/home";
    },
    async setImageBackground() {
      await this.$vs.loading();
      try {
        this.parametro = await this.$http.get("getBackground");
        this.backgroundUrl =
            this.parametro.storage_cdn_url +
            "/" +
            this.parametro.imagem_background;
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
        ;
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  async mounted() {
    await this.setImageBackground();
    await this.getIp();
    document.addEventListener("keydown", (e) => {
      if (e.keyCode == 13) {
        this.login()
      }
    });
  },
};
</script>
<style>
</style>